// §4.4 partial — admin/whatsapp routes.
// Composer auto-collects this into routes.generated.ts.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const AdminWhatsappPage = lazyWithRetry(
  () => import("./pages/AdminWhatsappPage"),
);

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [{ path: "/admin/whatsapp", Component: AdminWhatsappPage }],
  },
];

export default routes;
